// @core/api/endpoints/task/set_task_custom_field.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  SetTaskCustomFieldRequest,
  TaskResponse,
} from '../../../types/task';

const BASE_PATH = '/task';

/**
 * Set custom field value
 * Sets or updates a custom field value on a task. Validates the value against the field definition (type, options, constraints). Updates both the EAV store and the denormalized snapshot atomically.
 */
export async function SetTaskCustomField(
  task_id: string,
  field_id: string,
  data: SetTaskCustomFieldRequest,
  options?: RequestOptions
): Promise<TaskResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/tasks/:task_id/custom-fields/:field_id`;
  requestPath = requestPath.replace(':task_id', encodeURIComponent(task_id));
  requestPath = requestPath.replace(':field_id', encodeURIComponent(field_id));
  const requestOptions = options;
  return client.put<TaskResponse>(requestPath, data, requestOptions);
}
